export const actionType = {
  GET_HEADER_REQUEST: 'GET_HEADER_REQUEST',
  GET_HEADER_RECEIVED: 'GET_HEADER_RECEIVED'
}
export const getHeader = () => ({
  type: actionType.GET_HEADER_REQUEST,
});
  
  